// loads scripts that need to be on page - every entrypoint should import this!
import './kickstart';
import Scroller from '@newswire/scroller';

//////////////////////////////////////
// making the nav appear and change //
//////////////////////////////////////

var timeline = document.querySelector('nav#timeline-nav');

// sets up the scroller instance, pass in the container and an array of all the scenes
const scroller = new Scroller({
  container: document.querySelector('.timeline-section-container'),
  scenes: document.querySelectorAll('.timeline-event'),
  offset: 0.8,
});

// the `enter` event works as you expect with scenes...
scroller.on('scene:enter', (d) => {
  // get the attribute from the event and check it
  // against the nav years to add the active class
  var eventID = d.element.getAttribute('id');

  // look for the image
  var image = d.element.querySelector('img.item_photo');
  if (image) {
    image.classList.add('active-image');
  }

  var activeYear = timeline.querySelector('ul li a.active');

  if (activeYear) {
    activeYear.classList.remove('active');
    var navYear = timeline.querySelector(
      "ul li a[data-year='" + eventID + "']"
    );
    navYear.classList.add('active');
  } else {
    var navYear = timeline.querySelector(
      "ul li a[data-year='" + eventID + "']"
    );
    navYear.classList.add('active');
  }
});

scroller.on('scene:exit', (d) => {});

// ...but if a container is passed, events fire for it as well!
scroller.on('container:enter', (d) => {
  timeline.classList.add('fixed-nav');
});

scroller.on('container:exit', (d) => {
  timeline.classList.remove('fixed-nav');
});

scroller.init();
